import {toRef} from "vue";
import {useUserinfo} from "@/stores/userinfo";

import zh from "./i18nWords/TraditionalChinese"
import en from "./i18nWords/English"
import szh from "./i18nWords/SimplifiedChinese"

const langs = {
    zh: "中文（繁體）",
   // szh: "中文(简体)",
    en: "English"
}

const countryMap = {
    "HK": zh,
    "US": en,
    //"CN": szh,
}

const langMap = {
    "zh": zh,
    "en": en,
    //"szh": szh,
}

export default {
    install: (app) => {
        const userInfoRef = toRef(useUserinfo())
        app.provide('i18n', {
            tkey: (key, countryCode) => {
                if (null != countryCode){
                    return null == countryMap[countryCode] ? zh[key] : countryMap[countryCode][key]
                }else if (null != userInfoRef.value && null != userInfoRef.value.lang){
                    return langMap[userInfoRef.value.lang][key]
                }else {
                    return zh[key]
                }
            },
            getLangs: () => {
                return langs
            }
        })

    }
}